import { numeral } from '../numeral';
numeral.register('format', 'currency', {
    regexps: {
        format: /(\$)/
    },
    format(value, format, roundingFunction) {
        const locale = numeral.locales[numeral.options.currentLocale];
        const { _ } = numeral;
        const symbols = {
            before: format.match(/^([+|\-|(|\s|$]*)/)[0],
            after: format.match(/([+|\-|)|\s|$]*)$/)[0]
        };
        let symbol;
        format = format.replace(/\s?\$\s?/, '');
        let output = _.numberToFormat(value, format, roundingFunction);
        if (value >= 0) {
            symbols.before = symbols.before.replace(/[-(]/, '');
            symbols.after = symbols.after.replace(/[-)]/, '');
        }
        else if (value < 0 && !symbols.before.includes('-') && !symbols.before.includes('(')) {
            symbols.before = `-${symbols.before}`;
        }
        for (let i = 0; i < symbols.before.length; i++) {
            symbol = symbols.before[i];
            switch (symbol) {
                case '$':
                    output = _.insert(output, locale.currency.symbol, i);
                    break;
                case ' ':
                    output = _.insert(output, ' ', i + locale.currency.symbol.length - 1);
                    break;
            }
        }
        for (let i = symbols.after.length - 1; i >= 0; i--) {
            symbol = symbols.after[i];
            switch (symbol) {
                case '$':
                    output =
                        i === symbols.after.length - 1
                            ? output + locale.currency.symbol
                            : _.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                    break;
                case ' ':
                    output =
                        i === symbols.after.length - 1
                            ? `${output} `
                            : _.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                    break;
            }
        }
        return output;
    }
});
